"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLogViewerTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Visibility = _interopRequireDefault(require("@mui/icons-material/Visibility"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _moment = _interopRequireDefault(require("moment"));
var _DmsTableButton = require("../DmsTableButton/DmsTableButton");
var _DmsTable = require("../DmsTable/DmsTable");
var _Permissions = require("../../constants/Permissions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsLogViewerTable = _ref => {
  let {
    logLevel,
    onDetailsClick
  } = _ref;
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("User").d("User"),
    column_name: "created_by_id",
    control: 'select',
    url: "/user/all",
    properties: {
      column_name: "created_by_id",
      text_template: '{user_name}',
      label: "user_name",
      value: "pk",
      filter: {
        field: 'created_by_id',
        value: 'pk'
      }
    },
    filter: false
  }, {
    label: _reactIntlUniversal.default.get("Date").d("Date"),
    column_name: "created_on",
    function: date => (0, _moment.default)(date).format("DD/MM/YYYY HH:mm:ss"),
    control: 'datetime',
    filter: false
  }, {
    label: _reactIntlUniversal.default.get("Description").d("Description"),
    column_name: "description",
    filter: false
  }, {
    label: _reactIntlUniversal.default.get("Details").d("Details"),
    permissions: [_Permissions.Permissions.POLLUX_PERMISSION],
    width: "4.17vw",
    sortable: false,
    element: row => /*#__PURE__*/_react.default.createElement(_DmsTableButton.DmsTableButton, {
      table: table,
      icon: /*#__PURE__*/_react.default.createElement(_Visibility.default, null),
      onClick: e => onDetailsClick(e, {
        data: row
      })
    })
  }];
  return /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: '/log/table',
    pre_filter: logLevel ? [{
      name: "level",
      value: logLevel
    }] : null,
    responsive: true,
    header: header,
    export_table: false,
    needs_authentication: true,
    managed: true
  });
};
exports.DmsLogViewerTable = DmsLogViewerTable;